/**
 * Shared shapes of the workspace: a drag and its drop target, the dock compass's geometry,
 * and a small number helper. No DOM, no state.
 */
import type * as L from "./layout";

/** A drop position under the pointer. */
export interface Target {
  areaId: string;
  zone: L.DropZone | null;
  /** The hovered group, relative to the workspace. */
  rect: { x: number; y: number; w: number; h: number };
}

/** A window being dragged. */
export interface Drag {
  window: string;
  target: Target | null;
}

/** Size of a compass square, and the distance between square centres. */
export const COMPASS = { size: 34, step: 42 };

/** Where each compass square sits, relative to the centre of the group. */
export const ZONES: [L.DropZone, number, number][] = [
  ["center", 0, 0],
  ["left", -1, 0],
  ["right", 1, 0],
  ["top", 0, -1],
  ["bottom", 0, 1],
];

/** Keeps `value` between `min` and `max`. */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), Math.max(min, max));
}
